import { Dispatch, RefObject } from "react";
import { react } from "uikit";

import BogPaymentsCurrency from "./components/BogPaymentsCurrency";
import BogPaymentsCountryIso from "./components/BogPaymentsCountryIso";

interface Context {
	bogClientSecret: string;
	bogClientId: string;
	bogApiUrl: string;
	currencyRef: RefObject<BogPaymentsCurrency.Ref | null>;
	countryIsoRef: RefObject<BogPaymentsCountryIso.Ref | null>;
	setBogClientIdError: Dispatch<boolean>;
	setBogClientSecretError: Dispatch<boolean>;
	setBogApiUrlError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isCurrency = this.context?.currencyRef.current?.validate();
		const isCountryIso = this.context?.countryIsoRef.current?.validate();
		const isBogClientSecret = !!this.context?.bogClientSecret.trim();
		const isBogClientId = !!this.context?.bogClientId.trim();

		if (!isBogClientId) {
			this.context?.setBogClientIdError(true);
		}

		if (!isBogClientSecret) {
			this.context?.setBogClientSecretError(true);
		}

		return [
			isCurrency,
			isCountryIso,
			isBogClientId,
			isBogClientSecret,
		].every((isValid) => isValid);
	}
}
